import { jsx as a, jsxs as u } from "react/jsx-runtime";
import l from "react";
import { c as r } from "../clsx-OuTLNxxd.js";
const p = "UnbundlingFareCardBase-module_card__-RSuu",
  b = "UnbundlingFareCardBase-module_mobile-expandable__6ie9I",
  h = "UnbundlingFareCardBase-module_content__Djq0v",
  _ = "UnbundlingFareCardBase-module_content-infographic__JeqWn",
  g = "UnbundlingFareCardBase-module_expandable-content__xghGl",
  m = "UnbundlingFareCardBase-module_expandable-content-infographic__y8kbC",
  C = "UnbundlingFareCardBase-module_expand-button__zF-jm",
  x = "UnbundlingFareCardBase-module_is-expanded__auy4R",
  B = "UnbundlingFareCardBase-module_status-chosen__lKuze",
  F = "UnbundlingFareCardBase-module_status-not-chosen__p0y1E",
  U = "UnbundlingFareCardBase-module_highlighted__s3DqX",
  n = {
    card: p,
    mobileExpandable: b,
    content: h,
    contentInfographic: _,
    expandableContent: g,
    expandableContentInfographic: m,
    expandButton: C,
    isExpanded: x,
    statusChosen: B,
    statusNotChosen: F,
    highlighted: U
  },
  v = _ref => {
    let {
      children: e,
      trackingName: t,
      highlighted: o = !1,
      className: i,
      status: d = "default"
    } = _ref;
    const c = l.Children.toArray(e).some(s => l.isValidElement(s) && s.type === f);
    return /* @__PURE__ */a("article", {
      className: r(n.card, {
        [n.mobileExpandable]: c,
        [n.highlighted]: o,
        [n.statusChosen]: d === "chosen",
        [n.statusNotChosen]: d === "not-chosen"
      }, i),
      "data-content-name": t,
      children: e
    });
  },
  y = _ref2 => {
    let {
      children: e
    } = _ref2;
    return /* @__PURE__ */a("div", {
      className: n.content,
      children: /* @__PURE__ */a("div", {
        className: n.contentInfographic,
        children: e
      })
    });
  },
  f = _ref3 => {
    let {
      children: e,
      isExpanded: t,
      expandButton: o
    } = _ref3;
    return /* @__PURE__ */u("div", {
      className: r(n.expandableContent, {
        [n.isExpanded]: t
      }),
      children: [/* @__PURE__ */a("div", {
        className: n.expandableContentInfographic,
        children: e
      }), /* @__PURE__ */a("div", {
        className: n.expandButton,
        children: o
      })]
    });
  };
export { v as UnbundlingFareCardBase, y as UnbundlingFareCardContent, f as UnbundlingFareCardExpandableContent };